import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'monorepo-dropzone',
  templateUrl: './dropzone.component.html',
  styleUrls: ['./dropzone.component.scss'],
})
export class DropzoneComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
